angular.module('app.filters').filter('exists', () => (haystack, needle, castTo, notEmpty) => {
    switch (castTo) {
        case 'string':
            needle = needle.toString();
            break;
        case 'int':
            needle = parseInt(needle);
            break;
    }

    if (!haystack) {
        return false;
    } else if ('string' === typeof haystack) {
        return haystack.includes(needle);
    } else if (_.isArray(haystack)) {
        const pos = haystack.indexOf(needle);
        return -1 !== pos ? (notEmpty ? haystack[pos] : true) : false;
    } else if ('object' === typeof haystack) {
        return 'undefined' !== typeof haystack[needle] ? (notEmpty ? haystack[needle] : true) : false;
    }

    return false;
});
